import { Box, Flex, Heading } from '@chakra-ui/react';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';

import useGetList from './useGetList';
import CampaignExecutionCard from './components/CampaignExecutionCard';

const CampaignExecution = () => {
  const {
    getCampaignExecutionList,
    campaignExecutionList,
    loading,
    totalPages,
  } = useGetList();

  const getCurrentComponent = () => {
    if (loading) return <Loading />;
    
    if (campaignExecutionList.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhum atendimento encontrado.
        </Box>
      );
    }

    return (
      <PaginationRouterContainer
        total={totalPages}
        onPaginationChange={getCampaignExecutionList}
      >
        {campaignExecutionList.map((execution) => (
          <CampaignExecutionCard
            key={execution.id}
            execution={execution}
            refetch={() => getCampaignExecutionList({})}
          />
        ))}
      </PaginationRouterContainer>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={8}>
        <Heading>Atendimentos</Heading>
      </Flex>

      {getCurrentComponent()}
    </Box>
  );
};

export default CampaignExecution;
